import { apiGet } from '../../../shared/api-client/index.js';

export type HotLeadReason = 'stale' | 'due' | 'high_value';

export interface HotLeadItem {
  deal: {
    id: string;
    title: string;
    amount: number | string;
    currency: string;
    stage: string;
    contactName: string | null;
  };
  reasons: HotLeadReason[];
  primaryReason: HotLeadReason;
  score: number;
}

export interface ListHotLeadsFilters {
  filter?: 'all' | HotLeadReason;
}

export function getHotLeadsQueryKey(workspaceId: string, filter?: 'all' | HotLeadReason): readonly [string, string, string] {
  return ['hot-leads', workspaceId, filter ?? 'all'] as const;
}

export async function listHotLeads(filters: ListHotLeadsFilters = {}): Promise<HotLeadItem[]> {
  const search = new URLSearchParams();
  if (filters.filter) {
    search.set('filter', filters.filter);
  }
  const path = search.size > 0 ? `/leads/hot?${search.toString()}` : '/leads/hot';
  return apiGet<HotLeadItem[]>(path);
}
